import Button from '../../components/Button';
import Card from '../../components/Card';
import CheckRole from '../../components/CheckRole';
import DataGridView from '../../components/DataGridView';
import { Input, TextAreaField } from '../../components/FormComponents';
import { H2, PageHeading } from '../../components/Headings';
import Modal from '../../components/Modal';
import useForums from '../../hooks/useForums';
import useLocale from '../../hooks/useLocale';
import { UsernameColumn } from '../ClinicCases/components/UserNameColumn';
import { DateColumn } from '../SharedComponents/DateColumn';
import { ActionsColumn } from './components/ActionsColumn';
import { NumberOfRepliesColumn } from './components/NumberOfRepliesColumn';

export function ForumsPage() {
  const { l } = useLocale();
  const {
    openModal,
    showModal,
    closeModal,
    titleRef,
    descriptionRef,
    handleSubmit,
    forums,
    handleDelete,
    getForums,
  } = useForums();

  const columns = [
    {
      header: l('title'),
      accessor: 'title',
      filtrable: true,
    },
    {
      header: l('user'),
      accessor: 'user.name',
      filtrable: true,
      component: UsernameColumn,
    },
    {
      header: `Num. ${l('replies').toLowerCase()}`,
      accessor: 'replies',
      filtrable: false,
      cellClass: 'text-center',
      component: NumberOfRepliesColumn,
    },
    {
      header: l('creation_date'),
      accessor: 'createdAt',
      cellClass: 'text-center',
      component: DateColumn,
    },
    {
      header: l('modification_date'),
      accessor: 'updatedAt',
      cellClass: 'text-center',
      component: DateColumn,
    },
    {
      header: l('actions'),
      component: ({ rowData, page, limit }) => (
        <ActionsColumn rowData={rowData} handleDelete={id => handleDelete(id, page, limit)} />
      ),
      cellClass: 'flex gap-3 justify-center',
    },
  ];

  return (
    <>
      <PageHeading title={l('forums')} image="/img/forum.svg">
        <CheckRole has="add_forums">
          <Button onClick={openModal}>{l('add')}</Button>
        </CheckRole>
      </PageHeading>

      <Card>
        <DataGridView
          columns={columns}
          data={forums.docs}
          getData={getForums}
          totalPages={forums.totalPages}
        />
      </Card>

      {/* <Card>
        <table className="w-full">
          <thead>
            <tr className="text-left border-b border-gray-600">
              <th>{l('title')}</th>
              <th>{l('name')}</th>
              <th># {l('replies').toLowerCase()}</th>
              <th>{l('creation_date')}</th>
              <th>{l('modification_date')}</th>
              <th>{l('actions')}</th>
            </tr>
          </thead>
          <tbody>
            {forums.map(forum => {
              return (
                <tr key={forum._id}>
                  <td>{forum.title}</td>
                  <td>{forum.user.name}</td>
                  <td>{forum.replies.length}</td>
                  <td>{formatDate(forum.createdAt)}</td>
                  <td>{formatDate(forum.updatedAt)}</td>
                  <td className="flex gap-3">
                    <CheckRole has="view_forums">
                      <Link
                        to={`/forums/${forum._id}`}
                        className="bg-black hover:bg-gray-700 px-2 py-1 rounded-md ease-in-out duration-200"
                      >
                        <img className="w-[25px]" src="/img/view.svg" alt="" />
                      </Link>
                    </CheckRole>
                    <CheckRole has="delete_forums">
                      <DangerButton onClick={() => handleDelete(forum._id)} />
                    </CheckRole>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Card> */}

      <Modal show={showModal} onClose={closeModal}>
        <H2>{l('add_forum')}</H2>
        <form onSubmit={handleSubmit}>
          <Input label={l('title')} reference={titleRef} />
          <TextAreaField label={l('description')} reference={descriptionRef} />
          <Button full type="secondary">
            {l('add')}
          </Button>
        </form>
      </Modal>
    </>
  );
}
